import { Component, inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { customEncode } from '@piqet-angular/data';
import { SharedService } from 'libs/data/src/lib/services/shared/shared.service';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'piqet-angular-product-chart-at-glance',
  templateUrl: './product-chart-at-glance.component.html',
  styleUrls: ['./product-chart-at-glance.component.scss'],
})
export class ProductChartAtGlanceComponent {
  //properties
  reportChartForm!: FormGroup;
  scenarioList: any;
  allowSelectScenario = 6;
  chartTypeList: any;
  comparisonByList: any;
  categoriesIncludeList: any;
  functionalUnitList: any;
  baseScenarioList: any;

  // injects
  fb = inject(FormBuilder);

  constructor(
    private router: Router,
    private cookieService: CookieService,
    private sharedService: SharedService
  ) {
    this.sharedService.scenarioNameFunc('Chart at a glance');
    this.reportChartForm = this.fb.group({
      scenarios: ['', [Validators.required]],
      chartType: [null, [Validators.required]],
      comparisonBy: [null, [Validators.required]],
      categoriesToInclude: [null, [Validators.required]],
      functionalUnit: [null, [Validators.required]],
      baselineFunctional: [null, [Validators.required]],
    });
  }

  commonInputSearchName(term: string, item: any) {
    return item.name.toLowerCase().includes(term.toLowerCase());
  }

  commonInputSearchDescription(term: string, item: any) {
    return item.description.toLowerCase().includes(term.toLowerCase());
  }

  compareFn(item1: any, item2: any): boolean {
    return item1 && item2 ? item1.id === item2.id : item1 === item2;
  }

  nextRoute() {
    const activeProductProjectId: any = localStorage.getItem('productConfigId');
    this.sharedService.accessProductSideBarData(() => {});
    this.router.navigate([
      `projects/product-configuration/${customEncode(
        btoa(activeProductProjectId)
      )}/report-generation`,
    ]);
  }
}
